import { LayoutComponent } from "../../../components"
import { Outlet } from "react-router-dom"

export const FactoryLayout = () => {
    return (
        <LayoutComponent selectedMenuItem={"factory"}>
            <Outlet />
        </LayoutComponent>
    )
}
